var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonitor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_21120_42120",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_21120_42120)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.24935 12.5H7.49935V9.16667H6.24935V10.2083H4.99935V11.4583H6.24935V12.5ZM8.33268 11.4583H14.9993V10.2083H8.33268V11.4583ZM12.4993 9.16667H13.7493V8.125H14.9993V6.875H13.7493V5.83333H12.4993V9.16667ZM4.99935 8.125H11.666V6.875H4.99935V8.125ZM6.66602 17.5V15.8333H3.33268C2.87435 15.8333 2.48199 15.6701 2.1556 15.3438C1.82921 15.0174 1.66602 14.625 1.66602 14.1667V4.16667C1.66602 3.70833 1.82921 3.31597 2.1556 2.98958C2.48199 2.66319 2.87435 2.5 3.33268 2.5H16.666C17.1243 2.5 17.5167 2.66319 17.8431 2.98958C18.1695 3.31597 18.3327 3.70833 18.3327 4.16667V14.1667C18.3327 14.625 18.1695 15.0174 17.8431 15.3438C17.5167 15.6701 17.1243 15.8333 16.666 15.8333H13.3327V17.5H6.66602ZM3.33268 14.1667H16.666V4.16667H3.33268V14.1667Z",
    fill: "#133F7D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitor);
export default __webpack_public_path__ + "static/media/monitor.a6ce46cbb1e190fac02e951289c1bb87.svg";
export { ForwardRef as ReactComponent };